module.exports = __webpack_public_path__ + "static/media/azure-card-icon.c20919f9.png";